import { render, staticRenderFns } from "./CatalogoConsultaList.vue?vue&type=template&id=03855975"
import script from "./CatalogoConsultaList.vue?vue&type=script&lang=js"
export * from "./CatalogoConsultaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports